/**
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the Commercial License found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _defaultRowExpandColumn = _interopRequireDefault(require("./defaultRowExpandColumn"));
var _isRowExpandEnabled_FromProps = require("@inovua/reactdatagrid-community/utils/isRowExpandEnabled_FromProps");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _default(columns, props) {
  if ((0, _isRowExpandEnabled_FromProps.isRowExpandEnabled_FromProps)(props)) {
    var col = _objectSpread(_objectSpread(_objectSpread({}, _defaultRowExpandColumn.default), props.rowExpandColumn && (0, _typeof2.default)(props.rowExpandColumn) === 'object' ? props.rowExpandColumn : null), {}, {
      id: _defaultRowExpandColumn.default.id
    });
    if (props.rowExpandColumn !== false) {
      columns = [col].concat(columns);
    }
  }
  return columns;
}